import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Entity} from '../classes/entity';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ExportInterfaceService {
    private baseUrl = 'export-interface';
    private mapsApiKey = 'AIzaSyCsmHP7f7TfPwo4qipAK9uzR1-aQxVgCRQ';
    private mapsBaseUrl = 'https://roads.googleapis.com/v1/snapToRoads';

    constructor(private apiService: ApiService,
                private http: HttpClient) {
    }


    get() {
        return this.apiService.getCall$<Entity[]>(`${this.baseUrl}`);
    }

    getSiblings(id: number) {
        return this.apiService.getCall$<Entity[]>(`${this.baseUrl}/${id}/siblings`);
    }

    snapToRoad(path: { lat: number, lng: number }[]) {
        const pathStr = path.map(p => `${p.lat},${p.lng}`).join('|');

        const url = `${this.mapsBaseUrl}?path=${pathStr}&interpolate=true&key=${this.mapsApiKey}`;

        return this.http.get(url);
    }

}
